export default "__VITE_PUBLIC_ASSET__c3f6bf26__"